// TER CONSTANTS LOCAL (takodje postoje i Termovent Konstante iz biblioteke u bezi)
const tclocal = {};

/*
TODO ovde prefixi za idente i slicne stvari...

    switch (_draftelschemakey) {
      case 'terkk$demper':
        prefix = 'DEM'
        break;
      case 'terkk$eliminatorkapi':
        prefix = 'ELK'
        break;
      case 'terkk$spoljnafiksnazaluzina':
        prefix = 'SFZ'
        break;
      case 'terkk$elasticnaveza':
        prefix = 'ELV'
        break;
      case 'terkk$panel':
        prefix = 'PAN'
        break;
      case 'terkk$modul$profilosnovni:
        prefix = 'PRF'
        break;
      default:
        prefix = 'XXX'
    };
  };
*/

/* 
success: uspeh,

translation['original'] = 'U prevodu';
translate()
*/

/*
TBA vs. TBC vs. TBD
These phrases are similar, but may be used for different degrees of indeterminacy:
    To be announced (TBA) or To be declared (TBD) – details may have been determined, but are not yet ready to be announced.
    To be confirmed (TBC), To be resolved (TBR),[1] or To be provided (TBP)[2] – details may have been determined and possibly announced, but are still subject to change prior to being finalized.
    To be determined (TBD) or To be decided[3] – the appropriateness, feasibility, location, etclocal. of a given event has not been decided.


NN
Nomen nescio (pronounced [ˈnoːmɛn ˈnɛskɪ.oː]), abbreviated to N.N., is used to signify an anonymous or unnamed person. From Latin nomen – "name", and nescio – "I do not know", it literally means "I do not know the name"


N/A
N/A or sometimes n/a is a common abbreviation in tables and lists for the phrase not applicable,[1][2][3][4] not available[3][4] or no answer. It is used to indicate when information in a certain table cell is not provided, either because it does not apply to a particular case in question or because the answer is not available. Such a notation can be used on many different types of forms.  
*/

tclocal.ADD = 'ADD';
tclocal.EDIT = 'EDIT';
tclocal.LIBADD = 'LIBADD';
tclocal.WIZADD = 'WIZADD';
tclocal.WIZEDIT = 'WIZEDIT';
tclocal.CONTINUEEDIT = 'CONTINUEEDIT';
tclocal.INFO = 'INFO'; // klasicna toast informacija
tclocal.VAZNO = 'VAZNO'; // vazna informacija
tclocal.WARNING = 'WARNING';
tclocal.ERROR = 'ERROR';
tclocal.ISSUE = 'ISSUE';
tclocal.RED = 'RED';
tclocal.ORANGE = 'ORANGE';
tclocal.GREEN = 'GREEN';
tclocal.BLUE = 'BLUE';


tclocal.IDENT_TBD = '__IDENT_TBD_';

tclocal.SUFIKS_SECENJE = '_S';
tclocal.KATEGORIJA_PP = 'PP';
tclocal.KATEGORIJA_M = 'M';

tclocal.JM_KOM = 'kom';
tclocal.JM_M = 'm';
tclocal.JM_MM = 'mm';
tclocal.JM_M2 = 'm2';
tclocal.JM_M3 = 'm3';
tclocal.JM_PAK = 'pak';


tclocal.YES = 'YES';
tclocal.NO = 'NO';
tclocal.SASINT_YES = 'YES';
tclocal.SASINT_NO = 'NO';

// ter protobomp consts
tclocal.ASSEMBLY_TER_SKLOP = 'ASSEMBLY_TER_SKLOP';
tclocal.PRIMITIVE_TER_MATERIJAL = 'PRIMITIVE_TER_MATERIJAL';
tclocal.PRIMITIVE_TER_PROFIL = 'PRIMITIVE_TER_PROFIL';
tclocal.PRIMITIVE_TER_LIM = 'PRIMITIVE_TER_LIM';
tclocal.PRIMITIVE_TER_KAMENAVUNA = 'PRIMITIVE_TER_KAMENAVUNA';
tclocal.ASSEMBLY_TER_SAS = 'ASSEMBLY_TER_SAS';

tclocal.ASSEMBLY_SKETCH_V1 = 'ASSEMBLY_SKETCH_V1';
tclocal.PROGRESSIVE_ASSEMBLY_SKETCH_V1 = 'PROGRESSIVE_ASSEMBLY_SKETCH_V1';
tclocal.PRIMITIVE_SKETCH_DIR_M_V1 = 'PRIMITIVE_SKETCH_DIR_M_V1';
tclocal.PRIMITIVE_SKETCH_OPS_V1 = 'PRIMITIVE_SKETCH_OPS_V1';

export default tclocal;